import './chart_of_the_most_ordered_prds.css'
import React from 'react';
import Loading_animation_view from '../../../loading_animation_view/loading_animation_view';

  
  
const Chart_of_the_most_ordered_prds = ({data})=>{


  return (
    <div className='charts_of_the_most_ordered_prds_container'>
     <div className='container'>
       {
         data===null
         ?<Loading_animation_view />
         :<>
            <div className="categorie_container">
                <div className="order_of_the_most_ordered_prds" style={{backgroundColor:"rgb(243 184 62)"}} ><span>{data[0].count}</span></div>
                <div className="name_of_the_most_ordered_prds" style={{backgroundColor: "#b8c6db",backgroundImage: "linear-gradient(220deg, rgb(243 184 62) 0%, rgb(246 222 172) 74%)"}}>{data[0].product_code}</div>
            </div>
            <div className="categorie_container">
                <div className="order_of_the_most_ordered_prds" style={{backgroundColor:"#b8c6db"}} ><span>{data[1].count}</span></div>
                <div className="name_of_the_most_ordered_prds" style={{backgroundColor: "#b8c6db",backgroundImage: "linear-gradient(220deg, #b8c6db 0%, #eff7fa 74%)"}}>{data[1].product_code}</div>
            </div>
            <div className="categorie_container">
                <div className="order_of_the_most_ordered_prds" style={{backgroundColor:"#CD7F32"}} ><span>{data[2].count}</span></div>
                <div className="name_of_the_most_ordered_prds" style={{backgroundColor: "#b8c6db",backgroundImage: "linear-gradient(220deg, #CD7F32 0%, rgb(246 211 177) 74%)"}}>{data[2].product_code}</div>
            </div>
         </>
       }
     </div>        
     </div>        
  );
}


export default React.memo(Chart_of_the_most_ordered_prds)